/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import BaseCom from "../components/BaseCom";
import { withParamsAndNavigate } from "../components/WithParamsAndNavigate";

class ClientLanding extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        setTimeout(() => {
            this.props.navigate('login');
        }, 100);
    }

    componentDidUpdate(prevProps) {
    }

    componentWillUnmount() {
    }

    render() {
        return <></>;
    }
}

export default withParamsAndNavigate(ClientLanding);